import * as React from 'react';
import styled from 'styled-components';

interface Props {
  active: boolean;
}

export class Burger extends React.Component<Props, {}> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <BurgerComponent>
        <Bar className={this.props.active ? 'open1' : ''} />
        <Bar className={this.props.active ? 'open2' : ''} />
        <Bar className={this.props.active ? 'open3' : ''} />
      </BurgerComponent>
    );
  }
}

const BurgerComponent = styled.div`
  display: inline-block;
  cursor: pointer;

  & > .open1 {
    -webkit-transform: rotate(-45deg) translate(-4px, 4px);
    transform: rotate(-45deg) translate(-4px, 4px);
  }

  & > .open2 {
    opacity: 0;
  }

  & > .open3 {
    -webkit-transform: rotate(45deg) translate(-6px, -6px);
    transform: rotate(45deg) translate(-6px, -6px);
  }
`;

const Bar = styled.div`
  width: 25px;
  height: 2px;
  border-radius: 2px;
  background-color: ${({ theme }) =>
    theme.colors.primaryFontColor ||
    theme.primaryFontColor ||
    theme.burger.color};
  margin: 5px 0;
  transition: 0.4s;
`;
